export default function ({ store, redirect, app }) {
  // User is logged in
  const isLoggedIn = store.getters['auth/isLoggedIn']

  // If user is not authenticated redirect to login
  if (!isLoggedIn) {
    return redirect(app.localePath('/area-restrita'))
  }
}
